import { Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import etiquetaActivoFijoPdf from "../../../../Pdf/etiquetaActivoFijoPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Etiqueta de UNA sola unidad — recibe entradaSalidaId. Mismo patron que
// Pages/Panel/Lotes/ModalEtiquetasLote/ModalEtiquetasLote.js.
class ModalEtiquetaActivoFijo extends Component {
  state = {
    loading: false,
    datos: null,
    conDatosEmpresa: true,
    pdf: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.setState({ conDatosEmpresa: true, datos: null }, () => this.consultarDatos());
    }
  }

  consultarDatos() {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/datosEtiquetaActivoPdf",
        { entradaSalidaId: this.props.entradaSalidaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.unidades) {
          this.setState({ datos: res.data, loading: false }, () => this.generarPdf(this.state.conDatosEmpresa));
        } else {
          message.error("No se encontró la unidad para generar la etiqueta");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al generar el documento");
        this.setState({ loading: false });
      });
  }

  generarPdf(conDatosEmpresa) {
    if (!this.state.datos) return;
    etiquetaActivoFijoPdf(this.state.datos, { conDatosEmpresa }).then((dd) => {
      const pdf = pdfMake.createPdf(dd);
      this.setState({ pdf }, () => {
        pdf.open({}, window.frames["EtiquetaActivoFijoIframe"]);
      });
    });
  }

  cambiarOpcion(conDatosEmpresa) {
    if (conDatosEmpresa === this.state.conDatosEmpresa) return;
    this.setState({ conDatosEmpresa }, () => this.generarPdf(conDatosEmpresa));
  }

  descargarPdf() {
    if (this.state.pdf) {
      const folio = this.props.folio || "Activo";
      this.state.pdf.download(`Etiqueta_${folio}.pdf`);
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    const { conDatosEmpresa } = this.state;
    return (
      <ModalItem
        title="Etiqueta de Activo"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={900}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
          <Space>
            <ButtonItem
              type={conDatosEmpresa ? "primary" : "default"}
              cyan={conDatosEmpresa}
              blanco={!conDatosEmpresa}
              icon={<PrinterOutlined />}
              onClick={() => this.cambiarOpcion(true)}
            >
              Con datos de empresa
            </ButtonItem>
            <ButtonItem
              type={!conDatosEmpresa ? "primary" : "default"}
              cyan={!conDatosEmpresa}
              blanco={conDatosEmpresa}
              icon={<PrinterOutlined />}
              onClick={() => this.cambiarOpcion(false)}
            >
              Sin datos de empresa
            </ButtonItem>
          </Space>
          <Space>
            <ButtonItem icon={<DownloadOutlined />} type="primary" onClick={() => this.descargarPdf()}>
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>

        <iframe
          title="Etiqueta Activo Fijo"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="EtiquetaActivoFijoIframe"
          name="EtiquetaActivoFijoIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalEtiquetaActivoFijo);
